import AgAgentManage from '@/pages/agentManage/agAgentManage'

export default [
  {
    path: '/agAgentManage',
    name: 'AgAgentManage',
    component: AgAgentManage,
    meta: { name: '账户管理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/agentManage/agAgentManage.js